var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('NotificationsList',{attrs:{"notifications":_vm.notifications,"user":_vm.user,"title":"My Inbox","detailLink":"/member/inbox"},on:{"filter":_vm.filter}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }